module.exports = __webpack_public_path__ + "img/recruit_catch.91dc3306.jpg";